<template>
  <div class="wrapper">
    <app-page title= 'Информация о пользователе'>
      <p> <strong>ФИО:</strong> {{ fio }}</p>
      <p> <strong>Телефон:</strong> {{ mobile }}</p>
      <p> <strong>Номер договора:</strong> {{ docs }}</p>
      <p> <strong>Email:</strong> {{ mail }}</p>
      <p> <strong>Адрес:</strong> {{ home }}</p>
      <p> <strong>Оборудование:</strong> {{ equip }}</p>
      <p> <strong>Договор действителен до:</strong> {{ date }}</p>
      <p> <strong>Трест:</strong> {{ location }}</p>
      <p> <strong>Кто создал пользователя:</strong> {{creator}} </p>
      <p> <strong>Когда создали пользователя:</strong> {{creationDate}} </p>

      <button class="btn primary" @click="modal = true">Обновить</button>
      <button class="btn danger" @click="remove">Удалить</button>
      <button class="btn warning" @click="back">Назад</button>

      <teleport to="body">
        <request-modal v-if="modal" title="Обновить данные пользователя" @close="modal = false">
          <user-body @created="modal = false"></user-body>
        </request-modal>
      </teleport>
    </app-page>
  </div>
</template>

<script>

import UserBody from "@/components/ui/UserBody";
import RequestModal from "@/components/ui/RequestModal";
import AppPage from "@/components/backend/AppPage";
import {useRoute, useRouter} from 'vue-router';
import {ref, onMounted, reactive, provide} from 'vue'
import {useStore} from "vuex";

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const user = reactive({})

    const modal = ref(false)

    const home = ref()
    const fio = ref()
    const mobile = ref()
    const equip = ref()
    const date = ref()
    const location = ref()
    const docs = ref()
    const mail = ref()
    const id = ref()
    const creator = ref()
    const creationDate = ref()

    onMounted( () => {
      user.value = store._state.data.request.users
          .filter(user => {
            if (user._id === route.params.id) {
              return user
            }
          })
      fio.value = user.value[0].name
      mobile.value = user.value[0].phone
      docs.value = user.value[0].contract
      mail.value = user.value[0].email
      equip.value = user.value[0].equipment
      date.value = user.value[0].validity
      location.value = user.value[0].trest
      home.value = user.value[0].address
      id.value = route.params.id
      creator.value = user.value[0].creator
      creationDate.value = user.value[0].creationDate
    })

    provide('fio1', fio)
    provide('id1', id)
    provide('mobile1', mobile)
    provide('docs1', docs)
    provide('mail1', mail)
    provide('equip1', equip)
    provide('date1', date)
    provide('location1', location)
    provide('home1', home)

    const remove = async () => {
      await store.dispatch('request/removeUser', id)
      await router.push('/admin')
      await store.dispatch('request/getAuthUsers', null, {root: true})
    }

    const back = () => {
      router.go(-1)
    }

    return {
      home,
      docs,
      mail,
      equip,
      fio,
      mobile,
      date,
      location,
      id,
      creator,
      creationDate,
      modal,
      remove,
      back
    }
  },
  components: {AppPage, RequestModal, UserBody,}

}
</script>

<style scoped>

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

</style>